const baseURL = process.env.REACT_APP_SERVER_URL;

export const WEB_SERVICE = {
  getProjectListUrl: "/users/project",
  getProjectErrorUrl: "/users/project/{dsn}/error",
  getProjectDetailsUrl: "/users/project/",
};
